import { DefaultState } from 'store/types';

export const GET_RESERVATIONS_COUNT_DATA_REQUEST = 'GET_RESERVATIONS_COUNT_DATA_REQUEST';
export const GET_RESERVATIONS_COUNT_DATA_SUCCESS = 'GET_RESERVATIONS_COUNT_DATA_SUCCESS';
export const GET_RESERVATIONS_COUNT_DATA_FAILURE = 'GET_RESERVATIONS_COUNT_DATA_FAILURE';

export interface GetReservationsCountData {
  active: number;
  inactive: number;
  canceled: number;
}

export type GetReservationsCountState = DefaultState & {
  contents?: GetReservationsCountData;
};

interface ReadGetReservationsCountDataRequest {
  type: typeof GET_RESERVATIONS_COUNT_DATA_REQUEST;
};

interface ReadGetReservationsCountDataSuccess {
  type: typeof GET_RESERVATIONS_COUNT_DATA_SUCCESS,
  contents: GetReservationsCountData;
}

interface ReadGetReservationsCountDataFailure {
  type: typeof GET_RESERVATIONS_COUNT_DATA_FAILURE;
}

export type GetReservationsCountActionTypes = ReadGetReservationsCountDataRequest | ReadGetReservationsCountDataSuccess | ReadGetReservationsCountDataFailure;